
<app-header-title-text class="navbar-brand navbar-brand-center" :text="title"></app-header-title-text>
